"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSCookie = require("js-cookie");
var loadEnv_1 = require("./loadEnv");
exports.ROWAN_UI_ENV_KEY = 'rowan-ui-env';
var envFromCookie = JSCookie.get(exports.ROWAN_UI_ENV_KEY);
var windowEnv = loadEnv_1.default(envFromCookie);
exports.NAME = windowEnv.NAME;
exports.ASSET_ROOT = windowEnv.ASSET_ROOT;
exports.BOOKSTORE_ROUTER_BASE_NAME = windowEnv.BOOKSTORE_ROUTER_BASE_NAME;
exports.BUILDER_HOST = windowEnv.BUILDER_HOST;
exports.BUILDER_UI_HOST = windowEnv.BUILDER_UI_HOST;
exports.PLATFORM = windowEnv.PLATFORM;
exports.NATIVE_APPLICATION = windowEnv.NATIVE_APPLICATION;
exports.READER_BASE_URL = windowEnv.READER_BASE_URL;
exports.READER_URL = windowEnv.READER_URL;
exports.RUCKSACK_CALLBACK = windowEnv.RUCKSACK_CALLBACK;
exports.RUCKSACK_CLIENT_ID = windowEnv.RUCKSACK_CLIENT_ID;
exports.RUCKSACK_HOST = windowEnv.RUCKSACK_HOST;
exports.RUCKSACK_URL = windowEnv.RUCKSACK_URL;
exports.RUCKSACK_SECRET = windowEnv.RUCKSACK_SECRET;
exports.BOOKSHELF_URL = windowEnv.BOOKSHELF_URL;
exports.BOOKSHELF_AUTH_URL = windowEnv.BOOKSHELF_AUTH_URL;
exports.FEATURE_FLAG_URL = windowEnv.FEATURE_FLAG_URL;
exports.API_GATEWAY_URL = windowEnv.API_GATEWAY_URL;
exports.GRAPHQL_URL = exports.API_GATEWAY_URL + "graphql";
exports.SECURE_COOKIES = windowEnv.SECURE_COOKIES;
exports.COOKIE_DOMAIN = windowEnv.COOKIE_DOMAIN;
